<template>
  <div>
    <ElButton
      native-type="button"
      type="primary"
      icon="el-icon-edit"
      :loading="isLoading"
      @click.native="openEditCampaignBudgetModal"
    >
      {{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHANGE_BUDGET') }}
    </ElButton>
    <EditCampaignBudgetModalWrapper
      v-model="showEditCampaignBudgetModal"
      :credit="credit"
      :budget-allocation-limit="budgetAllocationLimit"
      @changed="emitChanged"
    />
  </div>
</template>

<script>
import EditCampaignBudgetModalWrapper from './EditCampaignBudgetModalWrapper';
import campaignId from '@/mixins/advertisement/campaignId';

export default {
  name: 'EditCampaignBudgetAction',
  components: {
    EditCampaignBudgetModalWrapper,
  },
  mixins: [campaignId],
  props: {
    budgetAllocationLimit: {
      type: Number,
      required: true,
    },
    credit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showEditCampaignBudgetModal: false,
      isLoading: false,
    };
  },
  methods: {
    emitChanged() {
      this.$emit('changed');
    },
    openEditCampaignBudgetModal() {
      this.showEditCampaignBudgetModal = true;
    },
  },
};
</script>
